module.exports = __webpack_public_path__ + "static/img/zeng2.b9e194b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeng2.jpg
// module id = 60G/
// module chunks = 1